import * as _ from 'lodash';
import {
	FETCH_PRODUCT_PRICE_LIST, FETCH_PRODUCT_PRICE_LIST_FULFILLED, FETCH_PRODUCT_PRICE_LIST_REJECTED,
	FETCH_PRODUCT_BY_ID, FETCH_PRODUCT_BY_ID_FULFILLED, FETCH_PRODUCT_BY_ID_REJECTED
} from '../actions';

export default (state = {
	data: null,
	fetching: false,
	fetched: false,
	error: null
}, action) => {
	switch (action.type) {
		case FETCH_PRODUCT_PRICE_LIST:
			return { ...state, fetching: true, fetched: false, error: null }
		case FETCH_PRODUCT_PRICE_LIST_FULFILLED:
			return {
				...state, fetching: false, fetched: true, error: null,
				pricelistData: action.payload,
				// data: Object.assign(state.data || {}, _.mapKeys(action.payload, 'id'))
				data: action.payload

			};
		case FETCH_PRODUCT_PRICE_LIST_REJECTED:
			return { ...state, fetching: false, fetched: false, error: action.payload, data: null };
		case FETCH_PRODUCT_BY_ID:
			return { ...state, fetching: true, fetched: false }
		case FETCH_PRODUCT_BY_ID_FULFILLED:
			return { ...state, fetching: false, fetched: true }
		case FETCH_PRODUCT_BY_ID_REJECTED:
			return { ...state, fetching: false, fetched: false, error: action.payload }
		default:
			return state;
	}
}
